import cn from "app/util/classnames";
import MenuButton from "app/ui/MenuButton";

interface VictoryPanelProps {
  tedImageUrl: string;
  tedImageName: string;

  // Pass these in to make sure the victory panel is sized correctly if it
  // appears before the image fully loads.
  tedImageWidth: number;
  tedImageHeight: number;

  // Unused at the moment. I was thinking of using it to display the
  // solved board layout using colored divs.
  solvedBoardLayout: string;

  onDismiss: () => void;
}

// This panel appears just after the victory animation plays in the Godot
// canvas. It lets the player look at the TED screenshot before continuing
// to the results screen.
export default function VictoryPanel(props: VictoryPanelProps) {
  return (
    <div
      className={cn(
        "w-full h-full",
        "flex justify-center items-center",
        "animate-fade-in",
      )}
    >
      <div // Background container
        className={cn("absolute inset-0 -z-10", "bg-green-dark")}
      />
      <div // Panel
        className={cn(
          "flex justify-center items-center",
          "w-full h-full md:w-auto md:max-h-[80%]",
          "px-4 py-10",
          "bg-green-light",
          "flex flex-col items-center gap-2",
          "md:border md:border-black",
          "animate-scale-in",
        )}
      >
        <div // Image container
          className={cn(
            "mt-1 mb-0 md:mb-1.5",
            "flex justify-center items-center",
            "w-fit",
            "overflow-hidden",
            "rounded-md",
            "shadow-[0_1px_3px_2px_rgba(0,0,0,0.1)]",
          )}
        >
          <img // TED image
            src={props.tedImageUrl}
            style={{
              aspectRatio: `${props.tedImageWidth} / ${props.tedImageHeight}`,
            }}
            className={cn(
              "bg-red-400",
              "aspect-auto object-contain",
              "h-full max-h-100 md:max-h-150 w-auto",
            )}
            alt="An image from a TED video"
            width={props.tedImageWidth}
            height={props.tedImageHeight}
          />
        </div>
        <p // Puzzle name
          className={cn("text-2xl font-condensed", "mb-2")}
        >
          {props.tedImageName}
        </p>
        <MenuButton onClick={props.onDismiss}>Continue</MenuButton>
      </div>
    </div>
  );
}
